import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import checkMarkSVG from "../../../assets/images/icons/checkmark.svg";
import PropTypes from "prop-types";
import { UncontrolledPopover, PopoverHeader, PopoverBody } from "reactstrap";
import wpUnderlay from "../../../assets/images/icons/wp_back_layer.svg";
import wpOutline from "../../../assets/images/icons/wp_outline.svg";
import wpCustom from "../../../assets/images/icons/wp_custom.svg";
import wpWhite from "../../../assets/images/icons/wp_white.svg";

// const vectorTypes = ["svg", "ai", "eps", "pdf"];
class WhiteprintModeField extends Component {
  render() {
    const {
      input: { value, onChange },
      itemsClassName,
    } = this.props;
    const whiteprintModes = [
      {
        key: "white_ink_underlay",
        title: this.context.t("White Ink Underlay"),
        description: this.context.t(
          "The design is printed on transparent adhesive. All colored elements of the design are backed with white, while the unprinted areas remain transparent. The white backdrop enhances the vibrancy of the colored elements."
        ),
        icon: wpUnderlay,
        help: true,
      },
      {
        key: "contoured_white_backfill",
        title: this.context.t("Contoured White Backfill"),
        description: this.context.t(
          "The design, printed on transparent adhesive, has all colored elements and spaces between them filled with white. This creates an outer contour cut effect around the design."
        ),
        icon: wpOutline,
        help: true,
      },
      {
        key: "white_layer_custom_print",
        title: this.context.t("White Layer Custom Print"),
        description: this.context.t(
          "We print your design as-is. Ensure your file includes a 'white' layer marking areas for white printing. Colors on transparent adhesive without this white layer may appear translucent. For guidance on marking white areas, please refer to our FAQ and Production File Guidelines."
        ),
        icon: wpCustom,
        help: true,
      },
      {
        key: "onlywhite",
        title: this.context.t("Solid White Print"),
        description: this.context.t(
          "This option involves printing solely using pure white as a solid color (1c) on transparent adhesive film. It is recommended for designs that are too delicate for single-color cutting plots or challenging to mount."
        ),
        icon: wpWhite,
        help: true,
      },
    ];
    const _itemsClassName = itemsClassName ? " " + itemsClassName : "";
    return (
      <div>
        {whiteprintModes.map((availableWhiteprintMode, index) => {
          const isChecked = availableWhiteprintMode.key === value;

          return (
            <div key={`whiteprint_mode_${index}`}>
              <Row
                className={
                  "cutting-field-label mb-2" +
                  _itemsClassName +
                  (isChecked ? " checked" : "")
                }
                htmlFor={availableWhiteprintMode.key}
                onClick={() => onChange(availableWhiteprintMode.key)}
                id={`whiteprint_mode_${index}_id`}
              >
                <Col xs={12} className="cutting-field-details">
                  <div className="cutting-field-details-title my-1">
                    <strong>{availableWhiteprintMode.title}</strong>
                  </div>
                </Col>
                <Col xs={4}>
                  <img
                    src={availableWhiteprintMode.icon}
                    className={"cutting-field-icon mr-2"}
                    alt={"cutting-field-icon"}
                    loading="lazy"
                  />
                </Col>
                <Col xs={8} className="cutting-field-details">
                  <div
                    className="cutting-field-details-subtitle"
                    id={`whiteprint_mode_${index}_id_details`}
                  >
                    <p className="small">
                      {availableWhiteprintMode.description.length >= 170
                        ? availableWhiteprintMode.description.slice(0, 170) +
                          "..."
                        : availableWhiteprintMode.description}
                    </p>
                  </div>
                  {isChecked && (
                    <img
                      src={checkMarkSVG}
                      className="cutting-field-checkmark"
                      alt="selected cutting"
                      loading="lazy"
                    />
                  )}
                </Col>
              </Row>
              {availableWhiteprintMode.help && (
                <UncontrolledPopover
                  trigger="hover"
                  delay={{ show: 0, hide: 0 }}
                  placement="right"
                  target={`whiteprint_mode_${index}_id_details`}
                >
                  <PopoverHeader>
                    {this.context.t(availableWhiteprintMode.title)}
                  </PopoverHeader>
                  <PopoverBody>
                    <div style={{ background: "#c6c6c6" }} className="p-5 mb-2">
                      <img
                        src={availableWhiteprintMode.icon}
                        className={"cutting-field-icon mr-2"}
                        alt={"cutting-field-icon"}
                        loading="lazy"
                        style={{ width: "100%" }}
                      />
                    </div>
                    <p>{this.context.t(availableWhiteprintMode.description)}</p>
                  </PopoverBody>
                </UncontrolledPopover>
              )}
            </div>
          );
        })}
      </div>
    );
  }
}

/**  define proptype for the 'translation' function  */
WhiteprintModeField.contextTypes = {
  t: PropTypes.func,
};

export default WhiteprintModeField;
